import { render, staticRenderFns } from "./mvAddFamily.vue?vue&type=template&id=142edee7&scoped=true"
import script from "./mvAddFamily.vue?vue&type=script&lang=js"
export * from "./mvAddFamily.vue?vue&type=script&lang=js"
import style0 from "./mvAddFamily.vue?vue&type=style&index=0&id=142edee7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142edee7",
  null
  
)

export default component.exports